import React from 'react'
import Box from '@material-ui/core/Box'
import Facilities from 'components/coaches-profile/profile-components/facilities'
import FormSubheader from '../form-subheader'
import { useCreateProfileFieldStyles } from '../field-styles'

const EditFacilitiesSection = ({ formFields, onSubmit }) => {
  const fieldClasses = useCreateProfileFieldStyles()

  return (
    <Box className={fieldClasses.fieldSection}>
      <FormSubheader
        title="Facilities"
        description="Facilities on your profile are view-only here. To add, remove, or update facility details, use Manage Facilities in settings."
      />
      <Facilities formFields={formFields} onSubmit={onSubmit} />
    </Box>
  )
}

export default EditFacilitiesSection
